import LessonFeedbackForm from './container';

export default LessonFeedbackForm;
